<template>
  <div v-if="!loading">
    <template v-if="this.products.length !== 0">
      <div style="text-align: right" class="mr-2">
        <v-btn outline small @click="refreshData" color="primary" style="min-width: 50px">
          <em class="fa fa-refresh" style="font-size: 17px" aria-hidden="true" /></v-btn
        >
      </div>

      <template v-for="(product, i) in products">
        <v-layout wrap :key="`product_${i}`">
          <v-flex xs8 class="pl-3 pr-3 pt-2 pb-2">
            <div style="display: flex">
              <img
                :src="product.photourl"
                aspect-ratio="1"
                alt
                class="grey lighten-2"
                style="width: 35px; height: 35px"
              />
              <label class="ml-2 primary-color">
                {{ product.name }} <span style="color: #000"> ({{ product.option }})</span></label
              >
              <label style="color: #000">x{{ product.quantity }}</label>
            </div>
          </v-flex>
          <v-flex xs4 class="pt-2 pb-2 pr-4 text-xs-right">
            <span style="color: #000">
              ฿{{
                (JSON.parse(product.discountprice) * JSON.parse(product.quantity)) | decimalFormat
              }}</span
            >
            <span
              class="mr-2 discount"
              v-if="JSON.parse(product.price) - JSON.parse(product.discountprice) !== 0"
              >฿{{
                (JSON.parse(product.price) * JSON.parse(product.quantity)) | decimalFormat
              }}</span
            >
          </v-flex>
        </v-layout>
      </template>
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label style="color: #000">ยอดรวม</label>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-4 pt-2 pb-2 text-xs-right">
          <label style="color: #000">฿{{ total | decimalFormat }}</label>
        </v-flex>
      </v-layout>
    </template>
    <v-card flat v-else>
      <div class="text-xs-center pa-3">
        <span>{{ $t('Not have any order now') }}</span>
      </div>
    </v-card>
  </div>
  <div v-else class="spinner text-xs-center pt-3">
    <v-progress-circular :indeterminate="true" :height="2" color="primary"></v-progress-circular>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      products: [],
      total: null,
      loading: true
    }
  },
  components: {},
  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    })
  },
  created() {
    this.fetchData()
  },
  mounted() {},
  methods: {
    async fetchData() {
      try {
        var { result } = await api.liveChatUserCart({
          pageid: this.$store.state.livechat.pageid,
          userid: this.$store.state.livechat.currentUser.userid
        })
        if (result) {
          this.loading = false
          this.products = result
          // console.log(this.products)

          this.products.map((item) => {
            this.total += JSON.parse(item.discountprice) * JSON.parse(item.quantity)
          })
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    refreshData() {
      this.products = []
      this.total = null
      this.loading = true
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.theme--light.v-card {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-currentcart.vue